import { ChevronDown } from 'lucide-react';
import type { ComponentProps } from 'react';

import { cn } from '../lib/cn';
import { controlDisabled, controlFocus, controlInvalid, controlSurface } from '../lib/control';

export type NativeSelectProps = ComponentProps<'select'> & {
  /** Classes do contêiner (largura/margem). `className` vai para o `<select>`. */
  readonly containerClassName?: string | undefined;
};

/**
 * `<select>` nativo estilizado (DS-04): melhor escolha para listas curtas e no celular (seletor do sistema).
 * Mesma altura, borda de controle (≥ 3:1) e foco do `Input`. Para listas longas/busca use o `Select` (Radix).
 */
export function NativeSelect({
  className,
  containerClassName,
  children,
  ...props
}: NativeSelectProps) {
  return (
    <div data-slot="native-select" className={cn('relative w-full', containerClassName)}>
      <select
        className={cn(
          'h-(--control-h) w-full min-w-0 appearance-none py-1 pr-9 pl-3 text-body',
          controlSurface,
          controlFocus,
          controlInvalid,
          controlDisabled,
          className,
        )}
        {...props}
      >
        {children}
      </select>
      <ChevronDown
        aria-hidden="true"
        className="pointer-events-none absolute top-1/2 right-3 size-4 -translate-y-1/2 text-muted-foreground"
      />
    </div>
  );
}
